module.exports = __webpack_public_path__ + "img/dp-min.11929d86.png";